<template>
  <div>
    <camera v-if="showCamera"
      :imagesList="photoType"
      v-on:closecamera="closeCamera">
    </camera>
    <signatures v-if="showSignature"
      :signaturesList="photoType"
      v-on:closesignature="closeSignature">
    </signatures>
    <div class="card-body text-center">
      <div class="card-title text-center">
        <h3>Tablet service</h3>
      </div>
      <form @submit.prevent>
        <h5 class="text-left mb-3">Visual inspection</h5>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.contentDispCorrect">
              All content Displayed Correctly
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.noBlankScreen">
              No blank screen or tiles
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.noTypo">
              No typo on message or location name
          </base-checkbox>
        </div>
        <h5 class="text-left mt-4 mb-3">Cables & Connections</h5>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.plugsSecure">
              Plugs, wires & cords secure
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.notLoose">
              Not too loose, to be easilly pulled or disconnected
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.notTight">
              Not too tight, to be piched or damaged
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.wiresInconspicuous">
              Cables and wires inconspicuous from visitors viewpoint
          </base-checkbox>
        </div>
        <h5 class="text-left mt-4 mb-3">Connectivity</h5>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.emailsSet">
              Emails & text messages can be sent from tablet
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.mapsLoading">
              Maps loading when profile is opened
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.contactEttractions">
              Contact Ettractions when leaving to make surethey can see tablet online
          </base-checkbox>
        </div>
        <h6 class="text-left mt-3 mb-3">At 1-888-303-0615</h6>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.cont">
              Content
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.logoMatchesLocation">
              "Welcome To" message & host logo matches location
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.notifyEttraction">
              If location requests changes, notify Ettraction immediately 1-888-303-0615
          </base-checkbox>
        </div>
        <h5 class="text-left mt-4 mb-3">Cleaning</h5>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.tabletCleaned">
              Tablet cleaned
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.standCleaned">
              Stand cleaned
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="tabletService.surroundAreaCleaned">
              Surrounding area cleaned
          </base-checkbox>
        </div>
        <h4 class="text-left mt-2 mb-2">If tablet has moved, notify Ettractions immediately</h4>
        <div class="form-group text-left">
          <label >Picture</label>
          <div>
            <a v-on:click='takePicture(["tabletService", "pictures"])' class="link"><i class="fa fa-camera" aria-hidden="true"></i> Tap to take picture</a>
            <badge type="primary" class="pull-right"><i class="fa fa-paperclip" aria-hidden="true"></i> {{tabletService.pictures.length}}</badge>
          </div>
        </div>
        <div class="form-group text-left">
          <label for="tabletProblem">Problem</label>
          <textarea class="form-control" id="tabletProblem" v-model="tabletService.tabletProblem" name="tabletProblem" rows="3"></textarea>
        </div>
        <div class="text-center">
          <base-button :disabled="disableSubmitButton" v-if="showSubmitButton() && !isJobActionCopleted(3)" type="primary" @click="tabletServiceSend" size='md' class="my-4">Submit</base-button>
        </div>
      </form>
    </div>
  </div>

</template>
<script>
import jobActionFormMixin from './../views/mixins/jobActionFormMixin'
import jobActionsMixin from './../views/mixins/jobActionsMixin'
import standsMixin from './../views/mixins/standsMixin'
import jobsMixin from './../views/mixins/jobsMixin'
import camera from './Camera'
import signatures from './Signatures'
export default {
  data () {
    return {
      showPreloader: false,
      showCamera: null,
      showSignature: false,
      images: [],
      signatures: [],
      photoType: null,
      jobAction: null,
      tabletService: {
        contentDispCorrect: null,
        noBlankScreen: null,
        noTypo: null,
        plugsSecure: null,
        notLoose: null,
        notTight: null,
        wiresInconspicuous: null,
        emailsSet: null,
        mapsLoading: null,
        contactEttractions: null,
        cont: null,
        logoMatchesLocation: null,
        notifyEttraction: null,
        tabletCleaned: null,
        standCleaned: null,
        surroundAreaCleaned: null,
        pictures: [],
        tabletProblem: null
      }
    }
  },
  props: {
    disableSubmitButton: {
      type: Boolean,
      default: false,
      description: 'Disable submit button'
    }
  },
  methods: {
    tabletServiceSend () {
      this.$emit('tabletServiceFormDataSend', this.tabletService)
    }
  },
  mixins: [jobActionFormMixin, jobActionsMixin, jobsMixin, standsMixin],
  components: {
    camera,
    signatures
  }
}
</script>
<style>
</style>
